import { type ChildOrder } from '@hooks-api/types/dataModel/fpOrder'
import { OrderFastpass } from './OrderFastpass'

interface AllOrdersFastpassProps {
  orders?: ChildOrder[]
}

export function AllOrdersFastpass({ orders }: AllOrdersFastpassProps) {
  return (
    orders?.map(order => <OrderFastpass key={order.id} order={order} />)
  )
}
